import React, {useCallback, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AxiosConfig from "../../services/AxiosConfig";

function ConfirmTokenPage() {
    const [token, setToken] = useState();
    const { user } = useParams();
    const getToken = async () => {
        const userMail = encodeURI(user);
        try {
            const response = await AxiosConfig.get(`/user/get_confirm_token/${userMail}`);

            if (response.data.success){
                setToken(response.data.token);
            } else {
                console.error(response.data.msg);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération du token :', error);
        }
    }

    useEffect(() => {
        getToken();
    }, [user]);

    return (
        <pre>{token}</pre>
    );
}

export default ConfirmTokenPage;
